import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import InputWrapper from "@coworker/apprestructured/src/task-management/components/InputWrapper/InputWrapper";
import { memo } from "react";
import { useTranslation } from "@coworker/locales";
import styles from "./CustomLocationTab.module.css";
export const MAX_CUSTOM_LOCATION_LENGTH = 255;
interface CustomLocationTabProps {
  customLocation: string;
  onCustomLocationChange: (newCustomLocation: string) => void;
  error: string | null;
}

export const CustomLocationTab = memo(
  ({
    customLocation,
    onCustomLocationChange,
    error,
  }: CustomLocationTabProps) => {
    const { t } = useTranslation();

    return (
      <InputWrapper error={error} data-testid="custom-location-input-wrapper">
        <FixaInputField
          className={styles["customLocationText"]}
          type="text"
          label={t("location3String")}
          id="custom-location-input"
          data-testid="custom-location-input"
          value={customLocation}
          onChange={(e) => onCustomLocationChange(e.target.value)}
        />
      </InputWrapper>
    );
  }
);
